import React from "react"

import { Container, TextAndButtonContainer } from "./styles"

const TextBlock = ({
  elRef,
  text,
  buttonElement,
  dataId,
  hideOnPageLoad,
  inGrid,
  isPromotionalPlacement = false,
  ...props
}) => {
  const hasButton = Boolean(buttonElement)

  return (
    <TextAndButtonContainer
      data-exp-id={dataId}
      hideOnPageLoad={hideOnPageLoad}
      inGrid={inGrid}
      hasButton={hasButton}
      isPromotionalPlacement={isPromotionalPlacement}
    >
      <Container
        ref={elRef}
        inGrid={inGrid}
        hasButton={hasButton}
        {...props}
        dangerouslySetInnerHTML={{ __html: text }}
        // this code is needed to support custom code at 100% width or it will not display
        isPromotionalPlacement={isPromotionalPlacement}
      />
      {buttonElement}
    </TextAndButtonContainer>
  )
}

export default TextBlock
